import { NAME_PROJECT } from '../../enum/constants';


export interface Additional {
  name: string;
  included: boolean;
  additionally?: boolean;
}

export interface Keys {
  olx: number;
  telegram: number;
}

export interface Tariff {
  readonly id: string;
  readonly key: string;
  keys: Keys
  title: string;
  color: string;
  price: number;
  sales_price: number;
  sales_percent: number;
  package_percent: number;
  sales: number;
  additional: Additional[];
}

export interface Advantage {
  img: string;
  description: string;
}

export interface Statist {
  name: string;
  count: string;
}

export interface Feedback {
  user: string;
  role: string;
  feedBack: string;
}

export interface Ability {
  img: string;
  description: string[]
}

export interface UsContact {
  icon: string;
  text: string;
  copyData?: string;
}

export const arrFeedbacks: Feedback[] = [
  {
    feedBack: 'Це чудове програмне забезпечення, я задоволений його надійністю, простотою та швидкістю роботи.',
    user: 'Dan Kaul',
    role: 'IT Consultant'
  },
  {
    feedBack: 'Завдяки відмінній підтримці, готовій вирішувати всі питання та виявляти помилки, ви завжди на кроці впереду, уникаючи небезпеки суперечок. Надійна підтримка — це наша сила.',
    user: 'Saru Mat',
    role: 'Customer'
  },
  {
    feedBack: `Перевершуючи очікування, ${NAME_PROJECT} пропонує надійну підтримку, яка завжди готова допомогти вам у вирішенні будь-яких питань та уникненні конфліктів. Не ризикуйте помилками, обирайте надійність з ${NAME_PROJECT}.`,
    user: 'Yommi Pat',
    role: 'Customer'
  }];

export const arrAbilities: Ability[] = [
  {
    img: '/assets/images/bg/mock_picture.png',
    description:
      [
        '• Робота з будь якою кількістю акаунтів OLX.',
        `• Моментальне спілкування з клієнтами прямо з ${NAME_PROJECT} без входу в OLX.`
      ]
  },
  {
    img: '/assets/images/bg/crossplatform.avif',
    description:
      [
        `• Працюйте в ${NAME_PROJECT} на всіх своїх пристроях.`,
        '• Спілкуйтесь з усіма клієнтами з усіх ваших акаунтів прямо з вашого телефона.',
      ]
  },
  {
    img: '/assets/images/bg/messaging.png',
    description:
      [
        '• Всі повідомлення приходять миттєво без збоїв та затримок.',
        '• Отримуйте зображення від клієнта, в будь-який час, без втрат.'
      ]
  },
  {
    img: '/assets/images/bg/telegram-notification.jpeg',
    description:
      [
        '• Отримуйте сповіщення про нові повідомлення від клієнта прямо в свій телеграм.',
      ]
  },
  {
    img: '/assets/images/bg/tech.jpg',
    description:
      [
        `• ${NAME_PROJECT} базується на сучасних, прогресивних та захищених технологіях.`,
        `• ${NAME_PROJECT} працює на серверах Amazon, що забезпечує її стабільну і безпечну роботу.`,
        '• Ваші акаунти повністю в безпеці і захищені.',
        `• Робота ${NAME_PROJECT} з OLX відбувається по офіційному API.`,
        '• Акаунти OLX не будуть заблоковані і переведені на бізнес.'
      ]
  },
  {
    img: '/assets/images/bg/support.avif',
    description:
      [
        '• Максимальна підтримка від нашої команди.',
        '• Телефон, чат підтримки.'
      ]
  },
  {
    img: '/assets/images/bg/future.webp',
    description:
      [
        '• Логістика, трекінг ваших посилок через сервіси: Нова Пошта, УП, МІСТ',
        `• Сповіщення в ${NAME_PROJECT} про оформлення OLX-доставки.`,
        '• Підключення E-mail сервісів.',
        `• Моментальне спілкування з клієнтами прямо з ${NAME_PROJECT} без входу в OLX.`
      ]
  },
];

export const arrStatistics: Statist[] = [
  {
    name: 'АКТИВНИХ КОРИСТУВАЧІВ',
    count: '100+'
  },
  {
    name: 'ПІДКЛЮЧЕНИХ АКАУНТІВ',
    count: '500+'
  },
  // {
  //   name: 'УСПІШНИХ УГОД',
  //   count: '20+'
  // },
  {
    name: 'ПОВІДОМЛЕНЬ ЗА ДЕНЬ',
    count: '1000+'
  },
];

export const arrAdvantages: Advantage[] = [
  {
    img: '/assets/svgs/home/user.svg',
    description: 'Зручний інтерфейс та інтуїтивний дизайн для легкого використання.'
  },
  {
    img: '/assets/svgs/home/users.svg',
    description: 'Широкий спектр інтеграцій з іншими системами та сервісами.'
  },
  {
    img: '/assets/svgs/home/productivity.svg',
    description: 'Висока робоча продуктивність і автоматизація завдань.'
  },
  {
    img: '/assets/svgs/home/support.svg',
    description: 'Підтримка та сервісна служба.'
  },
  {
    img: '/assets/svgs/home/shield.svg',
    description: 'Надійність і безпека даних.'
  },
  {
    img: '/assets/svgs/home/prices.svg',
    description: 'Широкий вибір планів та цінових пропозицій.'
  },
];

export const arrUsContacts: UsContact[] = [
  {
    icon: 'mail',
    text: 'jecrm.office@gmail.com',
    copyData: 'mailto:jecrm.office@gmail.com'
  },
  {
    icon: 'phone',
    text: '+380(99)048-49-80',
    copyData: 'tel:+380(99)048-49-80'
  },
  {
    icon: '',
    text: '+380(89)546-73-56',
    copyData: 'tel:+380(89)546-73-56'
  },
  {
    icon: 'location_city',
    text: 'Україна, м.Вінниця'
  },
];
